export default {
  'registerBenefit.member_recruitment': '會員募集',
  'registerBenefit.apply': '申請入會',
  'registerBenefit.follow_friend_tip': '成為品牌好友才能收到權益通知喔',
} as Record<string, string>;
